export const quoteActiveOptions: {name: string, value: boolean}[] = [
  {name: 'inforce', value: true},
  {name: 'all', value: false},
];